import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    dragAndDrop: '**Drag and drop your document here**',
    dropToUp: 'Drop to upload',
    error: 'Error while uploading receipt',
  },
  fr: {
    dragAndDrop: '**Déposez votre justificatif ici**',
    dropToUp: 'Lâchez pour télécharger',
    error: 'Erreur pendant le téléchargement du reçu',
  },
} as const);

export default locales;
